import { Gem, Trophy } from 'lucide-react';
import { Link } from 'react-router-dom';

type Props = {
  title: string;
  href: string;
};

export function FeaturedBanner({ title, href }: Props) {
  return (
    <div className="relative mb-6 overflow-hidden rounded-3xl bg-gradient-to-br from-brand-600 via-brand-700 to-indigo-800 p-6 text-white lg:p-8">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(91,184,255,0.4),_transparent_60%)]" />
      <div className="absolute -right-8 -top-8 opacity-10">
        <Gem className="h-48 w-48" />
      </div>
      <div className="relative">
        <div className="mb-3 inline-flex items-center gap-1.5 rounded-full bg-white/15 px-2.5 py-1 text-xs font-semibold backdrop-blur-sm">
          <Trophy className="h-3 w-3" />
          Featured this week
        </div>
        <h2 className="mb-2 max-w-md text-2xl font-bold leading-tight lg:text-3xl">{title}</h2>
        <p className="mb-4 max-w-md text-sm text-blue-100/90">
          Cast your vote before the deadline — one jem per person, choose wisely.
        </p>
        <Link
          to={href}
          className="inline-flex items-center gap-2 rounded-full bg-white px-4 py-2 text-sm font-semibold text-brand-700 transition-all hover:bg-blue-50 active:scale-[0.98]"
        >
          See entries
        </Link>
      </div>
    </div>
  );
}
